import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface NumberValidatorOptions {
    step: number;
    min: number;
    max: number;
    inclusiveMin: boolean;
    inclusiveMax: boolean;
    noScientific: boolean;
}

export const NumberValidator = (options: Partial<NumberValidatorOptions>): ValidatorFn => {
    const finalOptions = {
        ...{ inclusiveMin: true, inclusiveMax: true, noScientific: true },
        ...options,
    };
    const numberSubValidators: Function[] = [];

    if (finalOptions.noScientific) {
        numberSubValidators.push((value: string, number: number, errors: any) => {
            const regexp = new RegExp(/[eE]-?/g);

            if (regexp.test(value.toString())) {
                errors['noScientific'] = finalOptions;
            }
        });
    }

    if (finalOptions.min !== undefined && finalOptions.min !== null) {
        if (finalOptions.inclusiveMin) {
            numberSubValidators.push((value: string, number: number, errors: any) => {
                if (number < finalOptions.min!) {
                    errors['min'] = finalOptions;
                }
            });
        } else {
            numberSubValidators.push((value: string, number: number, errors: any) => {
                if (number <= finalOptions.min!) {
                    errors['min'] = finalOptions;
                }
            });
        }
    }

    if (finalOptions.max !== undefined && finalOptions.max !== null) {
        if (finalOptions.inclusiveMax) {
            numberSubValidators.push((value: string, number: number, errors: any) => {
                if (number > finalOptions.max!) {
                    errors['max'] = finalOptions;
                }
            });
        } else {
            numberSubValidators.push((value: string, number: number, errors: any) => {
                if (number >= finalOptions.max!) {
                    errors['max'] = finalOptions;
                }
            });
        }
    }

    if (finalOptions.step) {
        numberSubValidators.push((value: string, number: number, errors: any) => {
            // We do this because of math rounding errors in JS (try `5.02 / 0.1` in the console to see what I mean)
            if (!Number.isInteger(Number((number / finalOptions.step!).toPrecision(12)))) {
                errors['step'] = finalOptions;
            }
        });
    }

    return (control: AbstractControl) => {
        const errors: any = {};
        const value = control.value;

        if (value === undefined || value === null) {
            return null;
        }

        const number = Number(value);
        if (Number.isNaN(number)) {
            errors['number'] = { type: 'number' };
            return errors;
        }

        for (let i = 0; i < numberSubValidators.length; i++) {
            const numberSubValidator = numberSubValidators[i];

            numberSubValidator(value, number, errors);
        }

        return Object.keys(errors).length ? { number: errors } : null;
    };
};
